<template>
  <div>
    <div class="container-fluid">
      <div id="topinfo">
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="mx-auto col-xl-10 col-lg-11 col-md-12 col-sm-12 text-start mt-3 mb-0">
              <button
                class="btn btn-outline-secondary btn-sm px-3 ms-2 mt-1"
                @click="$router.go(-1)"
              >
                <font-awesome-icon :icon="['fas', 'arrow-rotate-left']" />
                Go back
              </button>
            </div>
            <div
              class="mx-auto col-xl-10 col-lg-11 col-md-12 col-sm-12 d-flex mb-2 flex-column card card-body blur shadow-blur"
            >
              <div class="card-header text-center">
                <h3 class="font-weight-bolder text-success text-gradient">Send Recipe Settings to PLCs</h3>
                <p class="mt-4 mb-0 text-justify">
                  Recipes with new Powder Amount Settings appear on this page, to be reviewed and sent to their
                  corresponding coating line PLCs.
                </p>
              </div>
            </div>
            <div
              class="mx-auto col-xl-10 col-lg-11 col-md-12 col-sm-12 d-flex mb-2 flex-column card card-body blur shadow-blur"
            >
              <div class="col text-end" style="margin-bottom: 0.25rem; padding-right: 1.5rem;">
                <button
                  class="btn btn-primary"
                  :disabled="refreshingFromPLC"
                  @click="refreshCurrentSettingsFromPLC();"
                >
                  <span v-if="!refreshingFromPLC">
                    Refresh Current Settings Data from PLC
                  </span>
                  <span v-else>
                    <span
                      class="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Refreshing...
                    <div v-if="refreshingFromPLC" style="max-width: 400px; margin-top: 10px;">
                      <soft-progress
                        :percentage="refreshProgress"
                        variant="gradient"
                        color="secondary"
                      />
                    </div>
                  </span>
                </button>
              </div>
              <div class="card-header row mt-0 pt-0">
                <send-recipes-line-card
                  v-for="[line_id, line_data] in Object.entries(settings_for_plcs_by_line_id)"
                  :key="line_id"
                  :line-id="String(line_id)"
                  :line-name="line_data.line_name"
                  :line-used-at="line_data.last_used_at"
                  :gun-names-by-gun-id="line_data.gun_names_by_gun_id"
                  :hopper-data-by-hopper-id="line_data.hopper_data_by_hopper_id"
                  @reload-data="getNewRecipeSettings();"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { faArrowRotateLeft, faCircleChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";

import axios from "axios";
import setTooltip from "@/assets/js/tooltip.js";
import SendRecipesLineCard from "@/views/applications/steelcase/components/SendRecipesLineCard.vue";
import SoftProgress from "@/components/SoftProgress.vue";

library.add([faArrowRotateLeft, faCircleChevronRight]);

export default {
  name: "ThicknessAdjustment",
  components: {
    FontAwesomeIcon,
    SendRecipesLineCard,
    SoftProgress,
  },
  data() {
    return {
      settings_for_plcs_by_line_id: {},
      refreshingFromPLC: false,
      refreshProgress: 0,
      refreshInterval: null,
      latest_current_settings_fetched_at: null,
    };
  },
  computed: {},
  mounted() {
    this.getData();
    setTooltip();
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;

    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
    };
  },
  methods: {
    async getData() {
      await this.getNewRecipeSettings();
    },
    async getNewRecipeSettings() {
      this.$store.state.isLoading = true;
      const response = await axios.get("api/v1/steelcase/get-settings-for-plcs/");
      this.settings_for_plcs_by_line_id = await response.data.settings_for_plcs_by_line_id;
      this.latest_current_settings_fetched_at = await response.data.latest_current_settings_fetched_at;
      this.$store.state.isLoading = false;
    },
    populateSettingsForPlcsMockData() {
      this.settings_for_plcs_by_line_id = {
        1: {
          line_name: "A-Dark Example",
          gun_names_by_gun_id: {
            1: "Gun with long name 1",
            2: "Gun with long name 2",
            3: "Gun with long name 3",
            4: "Gun with long name 4",
            5: "Gun with long name 5",
            6: "Gun with long name 6",
            7: "Gun with long name 7",
            8: "Gun with long name 8",
            9: "Gun with long name 9",
            10: "Gun with long name 0",
            11: "Gun with long name 1",
            12: "Gun with long name 2",
          },
          hopper_data_by_hopper_id: {
            9: {
              hopper_name: "Hopper-AAAA",
              plc_status: true,
              recipe_data_by_recipe_id: {
                33: {
                  recipe_name: "Name of the recipe is Walls but I'm trying a long name to see what happens",
                  updated_at: new Date().toLocaleString(),
                  new_powder_amount_setting_by_gun_id: {
                    1: 2.3,
                    2: 2.5,
                    3: 3.5,
                    4: 3.5,
                    5: 2.5,
                    6: 5.5,
                    7: 4.5,
                    8: 5.5,
                    9: 3.5,
                    10: 3.5,
                    11: 2.5,
                    12: 2.5,
                  },
                  current_powder_amount_setting_by_gun_id: {
                    1: 3.3,
                    2: 3.5,
                    3: 3.5,
                    4: 3.5,
                    5: 3.5,
                    6: 3.5,
                    7: 3.5,
                    8: 3.5,
                    9: 3.5,
                    10: 3.5,
                    11: 3.5,
                    12: 3.5,
                  },
                },
              },
            },
          },
        },
        2: {
          line_name: "B-Light Example",
          gun_names_by_gun_id: {
            1: "Gun Alpha",
            2: "Gun Beta",
            3: "Gun Gamma",
            4: "Gun Delta",
            5: "Gun Epsilon",
            6: "Gun Zeta",
          },
          hopper_data_by_hopper_id: {
            5: {
              hopper_name: "Hopper-BBBB",
              plc_status: false,
              recipe_data_by_recipe_id: {
                44: {
                  recipe_name: "Ceiling Coating Ultra",
                  updated_at: new Date().toLocaleString(),
                  new_powder_amount_setting_by_gun_id: {
                    1: 1.1,
                    2: 1.2,
                    3: 1.3,
                    4: 1.4,
                    5: 1.5,
                    6: 1.6,
                  },
                  current_powder_amount_setting_by_gun_id: {
                    1: 2.1,
                    2: 2.2,
                    3: 2.3,
                    4: 2.4,
                    5: 2.5,
                    6: 2.6,
                  },
                },
                45: {
                  recipe_name: "Floor Coating Max",
                  updated_at: new Date().toLocaleString(),
                  new_powder_amount_setting_by_gun_id: {
                    1: 2.0,
                    2: 2.1,
                    3: 2.2,
                    4: 2.3,
                    5: 2.4,
                    6: 2.5,
                  },
                  current_powder_amount_setting_by_gun_id: {
                    1: 2.8,
                    2: 2.9,
                    3: 3.0,
                    4: 3.1,
                    5: 3.2,
                    6: 3.3,
                  },
                },
              },
            },
            6: {
              hopper_name: "Hopper-CCCC",
              plc_status: true,
              recipe_data_by_recipe_id: {
                46: {
                  recipe_name: "Wall Coating Pro",
                  updated_at: new Date().toLocaleString(),
                  new_powder_amount_setting_by_gun_id: {
                    1: 1.7,
                    2: 1.8,
                    3: 1.9,
                    4: 2.0,
                    5: 2.1,
                    6: 2.2,
                  },
                  current_powder_amount_setting_by_gun_id: {
                    1: 2.7,
                    2: 2.8,
                    3: 2.9,
                    4: 3.0,
                    5: 3.1,
                    6: 3.2,
                  },
                },
              },
            },
          },
        },
      };
    },
    async refreshCurrentSettingsFromPLC() {
      if (this.refreshingFromPLC) return;
      const result = await this.$swal({
        title: "Manual Refresh Confirmation",
        text: [
          `Current settings data shown was last obtained today at ${this.latest_current_settings_fetched_at || 'unknown time'}.`,
          "This refresh process reads PLC tags again and can take up to 1 minute.",
          "Are you sure you want to proceed?"
        ].join('\n'),
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancel",
        confirmButtonText: "Yes, refresh now",
        customClass: {
          confirmButton: "btn btn-success w-40 px-1 m-2",
          cancelButton: "btn bg-gradient-danger w-40 px-1 m-2",
        },
        reverseButtons: true,
        buttonsStyling: false,
      });
      if (!result.isConfirmed) return;

      this.refreshingFromPLC = true;
      // Show spinner and progress bar and refresh after 50 seconds
      this.refreshProgress = 0;
      const duration = 50 * 1000;
      const intervalMs = 300;
      const steps = duration / intervalMs;
      let count = 0;

      this.refreshInterval = setInterval(() => {
        count++;
        this.refreshProgress = Math.min(100, Math.round((count / steps) * 100));
      }, intervalMs);

      try {
        const response = await axios.post("api/v1/steelcase/trigger-periodic-plc-settings-read/");
        this.refreshingFromPLC = false;

        if (response.status === 200) {
          await this.$swal({
            title: "Success!",
            text: "Current settings have been read successfully.",
            icon: "success",
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "btn btn-success w-40 px-1 m-2",
            },
            buttonsStyling: false,
          });
          window.location.reload();
        }
      } catch (error) {
        this.refreshingFromPLC = false;
        await this.$swal({
          title: "Error",
          text: "An error occurred while reading the current settings.",
          icon: "error",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-danger w-40 px-1 m-2",
          },
          buttonsStyling: false,
        });
      }
    },
  },
};
</script>

<style scoped>
.spinner-border {
  width: 1.2rem;
  height: 1.2rem;
  vertical-align: text-bottom;
}
</style>
